// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Files = function Files(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 3.75c0-1.379 1.121-2.5 2.5-2.5h5.16c.746 0 1.461.297 1.988.824l1.676 1.676H17.5c1.379 0 2.5 1.121 2.5 2.5v10c0 1.379-1.121 2.5-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5zm2.5-.625a.627.627 0 0 0-.625.625v12.5c0 .344.281.625.625.625h15a.627.627 0 0 0 .625-.625v-10a.627.627 0 0 0-.625-.625h-6.305c-.414 0-.812-.164-1.105-.457l-1.766-1.77a.94.94 0 0 0-.664-.273z"
  }));
};
